import {useEffect, useCallback, useMemo, useRef} from '@wordpress/element';

export const useCardFieldEvents = (
    {
        onError,
        onRemoveError,
        setValidatedField,
        cardFields,
        cardFieldRefs
    }) => {

    const currentData = useRef({
        cardFields,
        cardFieldRefs
    });

    useEffect(() => {
        currentData.current = {
            cardFields,
            cardFieldRefs
        };
    }, [
        cardFields,
        cardFieldRefs
    ]);

    const onBlur = useCallback((event) => {
        const {
            cardFields,
            cardFieldRefs
        } = currentData.current;
        const {
            fields,
            emittedBy
        } = event;
        setValidatedField(emittedBy, getField(emittedBy, fields));
        cardFields[emittedBy].removeClass('focused');
        cardFieldRefs[emittedBy].classList.remove('card-field--focused');
        const {
            isValid,
            isEmpty
        } = getField(emittedBy, fields);

        if (!isEmpty) {
            if (!isValid) {
                cardFieldRefs[emittedBy].classList.remove('card-field--valid');
                cardFieldRefs[emittedBy].classList.add('card-field--invalid');
                onError(emittedBy);
            }
        } else {
            cardFieldRefs[emittedBy].classList.remove('card-field--invalid');
            cardFields[emittedBy].removeClass('invalid');
            onRemoveError(emittedBy);
        }
    }, [
        onError,
        onRemoveError
    ]);

    const onFocus = useCallback((event) => {
        const {
            fields,
            emittedBy
        } = event;
        const {
            cardFields,
            cardFieldRefs
        } = currentData.current;
        setValidatedField(emittedBy, getField(emittedBy, fields));

        Object.keys(cardFields).forEach(key => {
            cardFields[key].removeClass('focused');
        })
        Object.keys(cardFieldRefs).forEach(key => {
            cardFieldRefs[key].classList.remove('card-field--focused');
        });
        cardFieldRefs[emittedBy].classList.add('card-field--focused');
        cardFields[emittedBy].addClass('focused');
    }, [
        onError,
        onRemoveError
    ]);

    const onChange = useCallback((event) => {
        const {
            fields,
            emittedBy
        } = event;
        const {
            cardFieldRefs
        } = currentData.current;
        const {
            isEmpty = false,
            isValid = false
        } = getField(emittedBy, fields);

        setValidatedField(emittedBy, getField(emittedBy, fields));

        onRemoveError(emittedBy);

        if (isValid) {
            cardFieldRefs[emittedBy].classList.add('card-field--valid');
        } else {
            cardFieldRefs[emittedBy].classList.remove('card-field--valid');
        }
    }, [
        onError,
        onRemoveError
    ]);

    const events = useMemo(() => ({
        onBlur,
        onFocus,
        onChange
    }), [onBlur, onFocus, onChange]);

    return {
        events
    }
}

const getField = (key, fields) => {
    const name = Object.keys(fields).find(name => {
        return name.toLowerCase().indexOf(key) > -1;
    });
    return fields[name];
}